import Vue from 'vue'

export default {
  // productClick: ({ rootState, rootGetters }, data) => new Promise(() => {
  //   const menuType = data.menuType || rootGetters['menus/currentMenu'].type
  //   const pricePlan = rootGetters['menus/currentPricePlan']
  //   const city = rootState.cities.active
  //
  //   let price = rootGetters['menus/currentMenuPrice']
  //
  //   Vue.gtm.trackEvent({
  //     'event': 'product_click',
  //     'product_price': price,
  //     'product_menu_type': menuType,
  //     'product_meal_days': pricePlan.numberOfMealDays,
  //     'product_city_id': city.id
  //   })
  // }),
  // addToCart: ({ rootState, rootGetters }) => new Promise(() => {
  //   const menu = rootGetters['menus/currentMenu']
  //   const pricePlan = rootGetters['menus/currentPricePlan']
  //   const city = rootState.cities.active
  //
  //   let price = rootGetters['menus/currentMenuPrice']
  //
  //   // пробуем продублировать тут данные товара, смотрим, что будет со статистикой проброса
  //   Vue.gtm.trackEvent({
  //     'event': 'add_to_cart',
  //     'product_price': price,
  //     'product_menu_type': menu.type,
  //     'product_meal_days': pricePlan.numberOfMealDays,
  //     'product_city_id': city.id
  //   })
  // }),
  // inputPhone: ({ rootState }, actionData) => new Promise(() => {
  //   // данные товара уже в dataLayer после productClick
  //   // в терминологии EEC это переход к шагу 1 чекаута
  //   // это событие тупо ввода телефона, без отправки
  //   Vue.gtm.trackEvent({
  //     'event': 'input_phone',
  //     'form_placement': actionData.formPlacement
  //     // 'order_id': rootState.orders.order.normal[0].id_H,
  //     // 'order_price': rootState.orders.order.normal[0].deb_price
  //   })
  //
  //   // window.VWO = window.VWO || []
  //   // window.VWO.push(['track.revenueConversion', rootState.orders.order.normal[0].deb_price])
  // }),
  // sendPhoneAsOrder: ({ rootState }, actionData) => new Promise(() => {
  //   // const menu = rootState.menus.currentMenu
  //   // const pricePlan = rootState.menus.currentPricePlan
  //   // const city = rootState.cities.active
  //   let data = {
  //     'event': 'go_to_step',
  //     'step_number': 2,
  //     'step_option': '',
  //     'form_placement': actionData.formPlacement
  //   }
  //   data.order_id = rootState.orders.order.normal[0].id_H
  //   data.user_id = rootState.client.profile.id_H
  //   data.order_price = rootState.orders.order.normal[0].deb_price
  //   data.external_interaction = rootState.client.profile.externalInteraction
  //   data.active_client_goal = rootState.client.profile.activeClientGoal
  //   let replaceAll = function (string, search, replace) {
  //     return string.split(search).join(replace)
  //   }
  //   let ph = replaceAll(actionData.phone, '+', '')
  //   ph = replaceAll(ph, '-', '')
  //   ph = replaceAll(ph, ' ', '')
  //   console.log(ph)
  //   data.phone_md5 = md5(ph)
  //
  //   // data.product_price = pricePlan.price
  //   // data.product_menu_type = menu.type
  //   // data.product_meal_days = pricePlan.numberOfMealDays
  //   // data.product_city_id = city.id
  //
  //   Vue.gtm.trackEvent(data)
  // }),
  // sendPhoneAsPseudoOrder: ({ rootState }, { stepOption, pseudoOrderId, pseudoOrderType, formPlacement }) => new Promise(() => {
  //   let data = {
  //     'event': 'go_to_step',
  //     'step_number': 2,
  //     'step_option': stepOption,
  //     'form_placement': formPlacement
  //   }
  //
  //   data.pseudo_order_id = pseudoOrderId
  //   data.pseudo_order_type = pseudoOrderType
  //
  //   Vue.gtm.trackEvent(data)
  // }),
  // goToStep: ({ rootState, rootGetters }, { stepNumber, stepOption, addProduct }) => new Promise(() => {
  //   let data = {
  //     'event': 'go_to_step',
  //     'step_number': stepNumber, // переход к шагу stepNumber
  //     'step_option': stepOption // значение checkout_option для шага (stepNumber - 1) (!!! минус 1 !!!
  //   }
  //
  //   // для всяких нестандартных флоу
  //   if (addProduct === undefined) {
  //     addProduct = false
  //   }
  //   if (addProduct) {
  //     const menu = rootGetters['menus/currentMenu']
  //     const pricePlan = rootGetters['menus/currentPricePlan']
  //     const city = rootState.cities.active
  //     data.product_price = pricePlan.price
  //     data.product_menu_type = menu.type
  //     data.product_meal_days = pricePlan.numberOfMealDays
  //     data.product_city_id = city.id
  //   }
  //
  //   Vue.gtm.trackEvent(data)
  // }),
  // createOrderFromAuthorized: ({ rootState, rootGetters }) => new Promise(() => {
  //   const menu = rootGetters['menus/currentMenu']
  //   const pricePlan = rootGetters['menus/currentPricePlan']
  //   const city = rootState.cities.active
  //
  //   Vue.gtm.trackEvent({
  //     'event': 'order_authorized',
  //     'product_price': pricePlan.price,
  //     'product_menu_type': menu.type,
  //     'product_meal_days': pricePlan.numberOfMealDays,
  //     'product_city_id': city.id,
  //     'order_id': rootState.orders.order.normal[0].id_H,
  //     'order_price': rootState.orders.order.normal[0].deb_price
  //   })
  // }),
  // // При рендере SelectMenuPlan
  // listMenuPlans: ({ rootState, rootGetters }) => new Promise(() => {
  //   const city = rootGetters['cities/active']
  //
  //   Vue.gtm.trackEvent({
  //     'event': 'products_list_initialize',
  //     'products_list': map(rootGetters['menus/sortedAndFilteredMenuTypes'], (type) => {
  //       let minMealDays = Object.keys(rootGetters['marketing/enabledMainOfferConfig'][type])[0]
  //       return rootGetters['enabledBusinessProduct'] + '-' + type + '-' + minMealDays + '-' + city.alias
  //     }, [])
  //   })
  // }),
  // // probably add some info here cuz it's not single event
  // openRecall: ({ rootState }) => new Promise(() => {
  //   Vue.gtm.trackEvent({
  //     'event': 'open_recall'
  //   })
  // }),
  // inputRecall: ({ rootState }) => new Promise(() => {
  //   Vue.gtm.trackEvent({
  //     'event': 'input_recall'
  //   })
  // }),
  // sendRecall: ({ rootState }, { pseudoOrderId }) => new Promise(() => {
  //   Vue.gtm.trackEvent({
  //     'event': 'send_recall',
  //     'pseudo_order_id': pseudoOrderId,
  //     'pseudo_order_type': 3
  //   })
  // }),
  // // probably add some info here cuz it's not single event
  // openHelp: ({ rootState }) => new Promise(() => {
  //   Vue.gtm.trackEvent({
  //     'event': 'open_help'
  //   })
  // }),
  // sendHelp: ({ rootState }) => new Promise(() => {
  //   Vue.gtm.trackEvent({
  //     'event': 'send_help'
  //   })
  // }),
  // changeUrl: ({ rootState }) => new Promise(() => {
  //   Vue.gtm.trackEvent({
  //     'event': 'change_url'
  //   })
  // }),
  singleEvent: ({ rootState }, event) => new Promise(() => {
    Vue.gtm.trackEvent({
      'event': event
    })
  }),
  // applyPromo: ({ rootState }, data) => new Promise(() => {
  //   Vue.gtm.trackEvent({
  //     'event': data.withOrder ? 'apply-promo-with-order' : 'apply-promo',
  //     'applied_promo': data.promocode,
  //     'applied_discount': data.discount
  //   })
  // }),
  // pushValues: ({ rootState }, data) => new Promise(() => {
  //   let dataLayer = window.dataLayer || []
  //   dataLayer.push(data)
  // }),
  sendSimpleEvent: ({ rootState }, data) => new Promise(() => {
    // Vue.gtm.trackEvent({
    //   'event': 'standard-markup-event',
    //   'markup_block': data.block,
    //   'markup_element': data.element,
    //   'markup_action': data.action,
    //   'markup_action_details': data.details,
    //   'markup_action_value': data.value
    // })
    Vue.gtm.trackEvent({ ...data, ...{ event: 'simple_event' } })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/gtm/actions.js